import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';

export function createHealthQueries(client: StoxlyClient) {
  return createQueryKeys('health', {
    // ['health', 'health']
    health: {
      queryKey: null,
      queryFn: ({ signal }) => client.healthGetHealth({ signal }),
    },
  });
}
